// Auth main object
export const FilterStorage = {
    getFilter,
    setFilter,
  };


  function getFilter(filter_name,type){

    let filter = JSON.parse(localStorage.getItem('ff_'+filter_name));
    if(filter){
        if(type==='filters'){
            return filter.filters;
        }
        else if (type==='pagination'){
            return filter.pagination;
        }
    }
    return null;

  }
  
  function setFilter(filter_name,type,params){
    
    // console.log('ENTRA AL FILTRO1')
    let filter = JSON.parse(localStorage.getItem('ff_'+filter_name));
    if(!filter){
        filter={}
    }
    
    if(type==='filters'){
        filter.filters = params;
        // console.log('ENTRA AL FILTRO')
        localStorage.setItem('ff_'+filter_name,JSON.stringify(filter));
        return true;
    }
    else if (type==='pagination'){
        // console.log('ENTRA AL pagination')
        // console.log(params)
        filter.pagination = params;
        localStorage.setItem('ff_'+filter_name,JSON.stringify(filter));
        return true;
    }

    return false;
    
  }
  